import { render, staticRenderFns } from "./ProductShare.vue?vue&type=template&id=8454a4de&scoped=true"
import script from "./ProductShare.vue?vue&type=script&lang=js"
export * from "./ProductShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8454a4de",
  null
  
)

export default component.exports